import React from "react";
import { Button } from "react-bootstrap";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import CloseIcon from "@mui/icons-material/Close";
import { IconAction } from "./TableUI/TableUI";

const AddButton = (props) => {
  return (
    <IconAction
      title="Edit"
      variant="primary"
      className="me-1"
      icon={<EditOutlinedIcon />}
      onClick={() => props.handleShow1(props?.id)}
    />
  );
};

const EditButton = (props) => {
  return (
    <IconAction
      title="Edit"
      variant="primary"
      className="me-1"
      icon={<EditOutlinedIcon />}
      onClick={() => props.handleShow1(props?.id)}
    />
  );
};

const DeletButton = (props) => {
  return (
    <IconAction
      title="Delete"
      variant="danger"
      icon={<DeleteOutlineIcon />}
      onClick={() => {
        props.showDeleteRecord(props?.id, props?.name);
      }}
    />
  );
};

const SaveButton = (props) => {
  return (
    <Button
      variant="success"
      type="button"
      onClick={props.handleSubmit}
      className="btn btn-save d-inline-flex align-items-center"
    >
      <SaveOutlinedIcon fontSize="small" className="me-2" /> {props.name}
    </Button>
  );
};

const CancelButton = (props) => {
  return (
    <Button
      onClick={props.handleClose}
      type="button"
      variant="danger"
      className="btn btn-cancel me-2 d-inline-flex align-items-center"
    >
      <CloseIcon fontSize="small" className="me-1" /> {props.name}
    </Button>
  );
};

const ViewButton = (props) => {
  return (
    <IconAction
      title="View Details"
      variant="neutral"
      className="me-1"
      icon={<VisibilityOutlinedIcon />}
      onClick={() => props.handleShow1(props?.id)}
    />
  );
};

export { AddButton, EditButton, DeletButton, CancelButton, SaveButton, ViewButton };
